import { Link } from "react-router-dom";
import type { NewsArticle } from "@/mocks/news";

interface NewsCardProps {
  article: NewsArticle;
  className?: string;
}

export default function NewsCard({ article, className = "" }: NewsCardProps) {
  return (
    <Link
      to={`/news/${article.id}`}
      className={`group flex gap-4 overflow-hidden rounded-lg border border-background-200 bg-background-50 p-3 transition-colors hover:border-primary-300 ${className}`}
    >
      <div className="h-20 w-28 shrink-0 overflow-hidden rounded-md bg-background-200 md:h-24 md:w-36">
        <img
          src={article.cover}
          alt={`${article.title} 配图`}
          title={`${article.title} - 芒果tv 娱乐资讯`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
      </div>
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex items-center gap-2 text-[11px] text-foreground-500">
          <span className="rounded bg-accent-100 px-1.5 py-0.5 font-medium text-accent-700">
            {article.category}
          </span>
          <span>{article.publishedAt}</span>
        </div>
        <h3 className="mt-1.5 line-clamp-2 font-heading text-sm font-semibold leading-snug text-foreground-950 group-hover:text-primary-600 md:text-base">
          {article.title}
        </h3>
        <p className="mt-1.5 line-clamp-2 hidden text-xs leading-relaxed text-foreground-500 sm:block">
          {article.summary}
        </p>
      </div>
    </Link>
  );
}